/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'device': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g _stroke="#FFF" _fill="none" fill-rule="evenodd" stroke-opacity=".8"><circle pid="0" cx="8" cy="8" r="4"/><path pid="1" d="M8 2.5V0M4 4L2 2m.5 6H0m4 4l-2 2M12 4l2-2m-.5 6H16m-4 4l2 2m-6 2v-2.5"/></g>'
  }
})
